var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.774,
    height: 12.25,
    viewBox: "0 0 8.774 12.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3905",
    "data-name": "Group 3905",
    transform: "translate(-58.634 -95.406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M.114,0H5.129a.114.114,0,0,1,.114.114V9.139a.114.114,0,0,1-.114.114H.114A.114.114,0,0,1,0,9.139V.114A.114.114,0,0,1,.114,0Z",
    transform: "translate(58.884 98.152)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M13.593,4.143A1.093,1.093,0,1,1,12.5,3.05,1.093,1.093,0,0,1,13.593,4.143Z",
    transform: "translate(49.018 96.217)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x2: 2.722,
    transform: "translate(60.17 102.786)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x2: 1.555,
    transform: "translate(60.75 103.997)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M13.065,16.773H11.04a.489.489,0,1,1,0-.978h2.025a.489.489,0,1,1,0,.978Z",
    transform: "translate(49.48 89.331)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    transform: "translate(61.408 95.406)",
    fill: "#ffd500",
    stroke: "#0165bc",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_15_12",
    "data-name": "Component 15 \\u2013 12",
    transform: "translate(63.547 97.545)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x1: 2.435,
    transform: "translate(0 0) rotate(45)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x1: 2.435,
    transform: "translate(0 1.722) rotate(-45)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubscriptionIcon);
export default __webpack_public_path__ + "static/media/no-subscription-icon.69a56b1b310f88f765cdb92419c48968.svg";
export { ForwardRef as ReactComponent };